/**
 *
 * libphonenumberは使用されていないにもかかわらずサイズが大きく、
 * かつtree shakingで削除されないため、パフォーマンスに影響しています。
 * tree shakingで削除されない原因は分かりませんでした。
 * この解決策としてpackage.json postinstallを使用してdist ファイルに
 * stubを挿入することでサイズの問題に対処をします。
 * 一時的な代替案であり、tree shakingの問題が解決出来そうな場合は削除してください。
 *
 *  */

module.exports = {
  PhoneNumberUtil: {
    getInstance() {

      return null;

    },
  },
};
